"use client";

import { c as _c } from "react/compiler-runtime";
import { type HTMLAttributes, useState } from "react";
import type { Offer } from "@local/offer/src/types";
import { cn } from "@local/utils/src/cn";
import Image from "next/image";
import { getCdnUrl } from "@local/utils/src/getCdnUrl";
import { Stars, Avatar, Button } from "../../ui";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { reviews as reviewsCatalog } from "@local/i18n/src/catalogs/reviews";
interface SingleReviewProps extends HTMLAttributes<HTMLDivElement> {
  review: NonNullable<Offer.FullWidthReviews["reviews"]>[number];
  market?: string;
}
export const SingleReview = t0 => {
  const $ = _c(52);
  let className;
  let market;
  let rest;
  let review;
  if ($[0] !== t0) {
    ({
      review,
      className,
      market,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = market;
    $[3] = rest;
    $[4] = review;
  } else {
    className = $[1];
    market = $[2];
    rest = $[3];
    review = $[4];
  }
  const [readMore, setReadMore] = useState(false);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] !== className || $[6] !== market || $[7] !== readMore || $[8] !== rest || $[9] !== review.content || $[10] !== review.image || $[11] !== review.starsRating) {
    const t = getT(getLanguageForMarket(market), {
      reviews: reviewsCatalog
    });
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = () => {
        setReadMore(true);
      };
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    const openReview = t8;
    if ($[20] !== className) {
      t4 = cn("flex w-full flex-col gap-4 md:mb-8", className);
      $[20] = className;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    t5 = rest;
    if ($[22] !== review.image) {
      t6 = review.image?.url && <Image src={getCdnUrl({
        src: review.image.url as string,
        width: review.image.width || 640
      })} width={review.image.width || 640} height={review.image.height || 640} alt={review.image.filename as string} className="aspect-square w-full" />;
      $[22] = review.image;
      $[23] = t6;
    } else {
      t6 = $[23];
    }
    const t9 = parseFloat(review.starsRating);
    if ($[24] !== t9) {
      t7 = <Stars rating={t9} />;
      $[24] = t9;
      $[25] = t7;
    } else {
      t7 = $[25];
    }
    t1 = "flex grow flex-col";
    const t10 = readMore ? review.content : review.content.substring(0, 94) + "...";
    if ($[26] !== t10) {
      t2 = <p className="mb-4">{t10}</p>;
      $[26] = t10;
      $[27] = t2;
    } else {
      t2 = $[27];
    }
    t3 = !readMore && <Button onClick={() => openReview()} className="mb-4 w-full max-w-full self-start text-left text-base! underline shadow-none!" variant="link">{t("reviews.readMore")}</Button>;
    $[5] = className;
    $[6] = market;
    $[7] = readMore;
    $[8] = rest;
    $[9] = review.content;
    $[10] = review.image;
    $[11] = review.starsRating;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
  }
  let t8;
  if ($[28] !== t1 || $[29] !== t2 || $[30] !== t3) {
    t8 = <div className={t1}>{t2}{t3}</div>;
    $[28] = t1;
    $[29] = t2;
    $[30] = t3;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  let t9;
  if ($[32] !== review.avatar || $[33] !== review.name) {
    t9 = <Avatar name={review.name} size="sm" image={review.avatar} />;
    $[32] = review.avatar;
    $[33] = review.name;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  let t10;
  if ($[35] !== review.name) {
    t10 = <b>{review.name}</b>;
    $[35] = review.name;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== review.location) {
    t11 = <span className="font-gray-700 block text-sm">{review.location}</span>;
    $[37] = review.location;
    $[38] = t11;
  } else {
    t11 = $[38];
  }
  let t12;
  if ($[39] !== t10 || $[40] !== t11) {
    t12 = <div><p className="mb-1 leading-tight">{t10}{t11}</p></div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== t12 || $[43] !== t9) {
    t13 = <div className="flex flex-row items-center gap-4">{t9}{t12}</div>;
    $[42] = t12;
    $[43] = t9;
    $[44] = t13;
  } else {
    t13 = $[44];
  }
  let t14;
  if ($[45] !== t13 || $[46] !== t4 || $[47] !== t5 || $[48] !== t6 || $[49] !== t7 || $[50] !== t8) {
    t14 = <div className={t4} {...t5}>{t6}{t7}{t8}{t13}</div>;
    $[45] = t13;
    $[46] = t4;
    $[47] = t5;
    $[48] = t6;
    $[49] = t7;
    $[50] = t8;
    $[51] = t14;
  } else {
    t14 = $[51];
  }
  return t14;
};